import React, { useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Session } from './utils/session';

const REPORT_PATHS = ['/StartStopActivity', '/MonthlyReport'];

function ReportsMenu() {
  const location = useLocation();
  const isReportsRoute = REPORT_PATHS.some((p) =>
    location.pathname.toLowerCase().startsWith(p.toLowerCase())
  );
  const [open, setOpen] = useState(isReportsRoute);

  return (
    <ul className="components">
      <li>
        <a
          href="#/"
          className={`sidebar-menu-toggle${isReportsRoute ? ' active' : ''}`}
          onClick={(e) => {
            e.preventDefault();
            setOpen((o) => !o);
          }}
        >
          <i className="fa-solid fa-chart-column" /> Reports
          <i
            className={`fa-solid fa-chevron-${open ? 'up' : 'down'} sidebar-submenu-caret`}
            aria-hidden="true"
          />
        </a>
        {open && (
          <ul className="sidebar-submenu">
            <li>
              <NavLink to="/StartStopActivity">
                <i className="fa-solid fa-list-check" /> Task Reports
              </NavLink>
            </li>
            <li>
              <NavLink to="/MonthlyReport">
                <i className="fa-solid fa-calendar-days" /> Monthly Report
              </NavLink>
            </li>
          </ul>
        )}
      </li>
    </ul>
  );
}

export default function Sidebar() {
  const navigate = useNavigate();

  const isAdmin = Session.isAdmin();
  const isTeamLeader = Session.isTeamLeader();

  const handleLogout = () => {
    Session.clear();
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login");
  };

  return (
    <nav id="sidebar">
      <div className="sidebar-header-brand">
        <div className="main-logo">
          <img src="/images/epa-global-logo.png" className="imgFluid_logo" alt="EPA Global" />
        </div>
      </div>

      <div className="sidebar-nav">
      {isAdmin && (
        <>
          <p className="sidebar-group-title">Analyze</p>
          <ul className="components">
            <li>
              <NavLink to="/dashboard">
                <i className="fa-solid fa-border-all" /> Dashboard
              </NavLink>
            </li>
          </ul>
          <ul className="components">
            <li>
              <NavLink to="/dailytask">
                <i className="fa-solid fa-list-check" /> Task
              </NavLink>
            </li>
          </ul>
          <ReportsMenu />
          <ul className="components">
            <li>
              <NavLink to="/teams">
                <i className="fa-solid fa-users" /> Teams
              </NavLink>
            </li>
            <li>
              <NavLink to="/members">
                <i className="fa-regular fa-user" /> Members
              </NavLink>
            </li>
          </ul>
        </>
      )}

      {isTeamLeader && (
        <>
          <p className="sidebar-group-title">Analyze</p>
          <ul className="components">
            <li>
              <NavLink to="/dashboard">
                <i className="fa-solid fa-border-all" /> Dashboard
              </NavLink>
            </li>
          </ul>
          <ul className="components">
            <li>
              <NavLink to="/dailytask">
                <i className="fa-solid fa-list-check" /> Task
              </NavLink>
            </li>
          </ul>
          <ReportsMenu />
          <ul className="components">
            <li>
              <NavLink to="/my-profile">
                <i className="fa-regular fa-circle-user" /> My Profile
              </NavLink>
            </li>
          </ul>
        </>
      )}

      {Session.isMember() && (
        <ul className="components">
          <li>
            <NavLink to="/dailytask">
              <i className="fa-solid fa-list-check" /> Task
            </NavLink>
          </li>
          <li>
            <NavLink to="/my-profile">
              <i className="fa-regular fa-circle-user" /> My Profile
            </NavLink>
          </li>
        </ul>
      )}

      <ul className="components">
        <li onClick={handleLogout}>
          <NavLink to="#/">
            <i className="fa-solid fa-right-from-bracket" /> Logout
          </NavLink>
        </li>
      </ul>
      </div>

      <div className="sidebar-footer-brand">
        <span className="logo_text_monitoing">
          <img src="/images/dashlogo.png" className="imgFluid_logo" alt="AI Monitoring" />
          <h3 className="sidebar-title">Monitoring</h3>
        </span>
        <p className="sidebar-powered-by">
          <span className="sidebar-powered-by-label">Powered by</span>
          <span className="sidebar-powered-by-brand">Avyak Infotech</span>
        </p>
      </div>
    </nav>
  );
}
